import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const SingleSelect = ({ label, value, onChange, options, name }) => {
  return (
    <FormControl
      fullWidth
      sx={{
        "& .MuiOutlinedInput-root": {
          width: "100%",
          borderRadius: "12px",
          backgroundColor: "#f9fafb",
        },
      }}
    >
      <InputLabel>{label}</InputLabel>
      <Select value={value} label={label} onChange={onChange} name={name}>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SingleSelect;
